export {BaseModel} from './BaseModel'
export {Auth} from './Auth'
export {Competition} from './Competition'
export {CompetitionRegistration} from './CompetitionRegistration'
export {InvoiceAddress} from './InvoiceAddress'
export {RegisteredClass} from './RegisteredClass'
export {RegisteredClassList} from './RegisteredClassList'
export {School} from './School'
export {User} from './User'



//////////////////
// WEBPACK FOOTER
// ./src/models/index.js
// module id = 22
// module chunks = 1